import { render, staticRenderFns, recyclableRender, components } from "./wo-slider.vue?vue&type=template&id=c45d7a3c&scoped=true&"
var renderjs
import script from "./wo-slider.vue?vue&type=script&lang=js&"
export * from "./wo-slider.vue?vue&type=script&lang=js&"
import style0 from "./wo-slider.vue?vue&type=style&index=0&id=c45d7a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45d7a3c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/wo-slider/components/wo-slider/wo-slider.vue"
export default component.exports